import SVGLoader from './SVGLoader';

const ChevronUpIcon = props => {
  return (
    <SVGLoader {...props}>
      <path d="M2.5,69.2c0.1,6,6.2,10,11.3,7.3c2.3-1.2,4.3-2.8,6.1-4.7c8.8-8.7,17.6-17.4,26.4-26.2c0.7-0.7,1.4-1.3,2.1-2c1-1.2,2-1,3,0c1.8,1.9,3.7,3.7,5.5,5.5c8,8,16,16,24.1,23.9c1.2,1.2,2.5,2.3,4,3.2c5.1,2.8,11.6-0.3,12.4-6c0.5-3.2-1.2-5.7-3.3-7.7c-10-9.9-20.1-19.8-30.2-29.7c-2.3-2.3-4.7-4.4-6.8-6.9c-4.2-4.7-10.2-4.2-14.5,0.1c-6.4,6.4-12.8,12.8-19.2,19.2c-6,6-12,12-18.1,18C3.5,65,2.3,66.9,2.5,69.2z" />
    </SVGLoader>
  );
};

export default ChevronUpIcon;
